import { MutationTree } from "vuex";
import { GuardTourState, GuardTour, GuardTourStep } from "./types";

export const mutations: MutationTree<GuardTourState> = {

	/** Guard Tour setup */
	setAreaSelectedId(state, selectedAreaId: number) {
		state.selectedAreaId = selectedAreaId;
	},
	setFilterTourTypeId(state, filterTourType: number) {
		state.filterTourTypeId = filterTourType;
	},
	setGuardTours(state, guardTours: GuardTour[]) {
		state.guardTours = guardTours;
	},
	setGuardTour(state, guardTour: GuardTour) {
		// Sort by step order
		if (guardTour.guardTourSteps) {
			guardTour.guardTourSteps.sort((a, b) => (a.stepOrder > b.stepOrder) ? 1 : -1)
		}

		const index = state.guardTours.findIndex(tour => tour.guardTourId == guardTour.guardTourId);
		if (index == -1) {
			state.guardTours.push(guardTour);
		} else {
			state.guardTours[index] = guardTour;
		}

		// Set the current guard tour as the tour we've just fetched
		state.currentGuardTour = guardTour;
	},
	mutateCurrentGuardTour(state, guardTour: any) {
		state.currentGuardTour = Object.assign(state.currentGuardTour, guardTour);
	},
	setCurrentGuardTour(state, currentGuardTour: GuardTour) {
		state.currentGuardTour = currentGuardTour;
	},
	setCurrentGuardTourTitle(state, title: string) {
		state.currentGuardTour.title = title;
	},
	setCurrentGuardTourSteps(state, guardTourSteps: GuardTourStep[]) {
		if (state.currentGuardTour && state.currentGuardTour.guardTourSteps) {
			guardTourSteps.forEach((tourStep: GuardTourStep, index: number) => {
				tourStep.stepOrder = index + 1;
			});

			state.currentGuardTour.guardTourSteps = guardTourSteps;
		}
	},
	pushGuardTourStep(state, guardTourStep: GuardTourStep) {
		if (state.currentGuardTour && state.currentGuardTour.guardTourSteps) {
			state.currentGuardTour.guardTourSteps.push(guardTourStep);
			state.currentGuardTour.guardTourSteps.forEach((tourStep: GuardTourStep, index: number) => {
				tourStep.stepOrder = index + 1;
			});
		}
	},
	removeGuardTourStep(state, guardTourStep: GuardTourStep) {
		if (state.currentGuardTour && state.currentGuardTour.guardTourSteps) {
			state.currentGuardTour.guardTourSteps.remove(guardTourStep);
			state.currentGuardTour.guardTourSteps.forEach((tourStep: GuardTourStep, index: number) => {
				tourStep.stepOrder = index + 1;
			});
		}
	},
	setScriptIdForGuardTourStep(state, { stepIndex, scriptId }) {
		if (state.currentGuardTour && state.currentGuardTour.guardTourSteps) {
			if (state.currentGuardTour.guardTourSteps[stepIndex]) {
				state.currentGuardTour.guardTourSteps[stepIndex].scriptId = scriptId;
			}
		}
	},
	setTitleForWaypointTourStep(state, { stepIndex, title }) {
		if (state.currentGuardTour && state.currentGuardTour.guardTourSteps) {
			if (state.currentGuardTour.guardTourSteps[stepIndex]) {
				state.currentGuardTour.guardTourSteps[stepIndex].mapLayerItemTitle = title;
			}
		}
	},
	addGuardTour(state, GuardTour: GuardTour) {
		state.guardTours.push(GuardTour);
	},
	deleteGuardTour(state, guardTourId: number) {
		const index = state.guardTours.findIndex(tour => tour.guardTourId == guardTourId);
		state.guardTours.splice(index, 1);
	},
	setWaypointMarkerPosition(state, position) {
		state.waypointMarkerPosition = position;
	},
	setCreatingWaypoint: (state, visible) => {
		state.creatingWaypoint = visible;
	},
	addItemToTour: (state, mapLayerItem) => {
		state.itemToAdd = mapLayerItem;
	},
	setShowTour: (state, showTour) => {
		state.showTour = showTour;
	},
	setLoadItemsFromMap: (state, loadItemsFromMap) => {
		state.loadItemsFromMap = loadItemsFromMap;
	},
	setMapItemList: (state, itemList) => {
		state.mapItemList = itemList;
	},
	setAssessmentTours: (state, assessmentTours) => {
		state.assessmentTours = assessmentTours
	}
}